import { mergePublicLocale } from './merge-locale';

export type Language = 'fr' | 'en' | 'es' | 'it' | 'de' | 'ar' | 'pt' | 'uk' | 'ru' | 'lb' | 'tr' | 'zgh';

export const defaultLanguage: Language = 'en';
export const supportedLanguages: Language[] = ['fr', 'en', 'es', 'it', 'de', 'ar', 'pt', 'uk', 'ru', 'lb', 'tr', 'zgh'];

// LyrraOne Landing
import frLyrraOneLandingTranslations from './lyrraone-landing/fr.json';
import enLyrraOneLandingTranslations from './lyrraone-landing/en.json';
import frLyrraOnePricingTranslations from './lyrraone-pricing/fr.json';
import enLyrraOnePricingTranslations from './lyrraone-pricing/en.json';
import lyrraoneFrPublicHeader from './public-header/lyrraone-fr.json';
import lyrraoneFrPublicFooter from './public-footer/lyrraone-fr.json';

// Landing
import frLandingTranslations from './landing/fr.json';
import enLandingTranslations from './landing/en.json';
import esLandingTranslations from './landing/es.json';
import itLandingTranslations from './landing/it.json';
import deLandingTranslations from './landing/de.json';
import landingPtPatch from './landing/pt.patch.json';
import landingUkPatch from './landing/uk.patch.json';
import landingRuPatch from './landing/ru.patch.json';
import landingLbPatch from './landing/lb.patch.json';

// Pricing
import frPricingTranslations from './pricing/fr.json';
import enPricingTranslations from './pricing/en.json';
import esPricingTranslations from './pricing/es.json';
import itPricingTranslations from './pricing/it.json';
import dePricingTranslations from './pricing/de.json';

// Accessibility
import frAccessibilityTranslations from './accessibility/fr.json';
import enAccessibilityTranslations from './accessibility/en.json';
import esAccessibilityTranslations from './accessibility/es.json';
import itAccessibilityTranslations from './accessibility/it.json';
import deAccessibilityTranslations from './accessibility/de.json';

// About
import frAboutTranslations from './about/fr.json';
import enAboutTranslations from './about/en.json';
import esAboutTranslations from './about/es.json';
import itAboutTranslations from './about/it.json';
import deAboutTranslations from './about/de.json';

// Contact
import frContactTranslations from './contact/fr.json';
import enContactTranslations from './contact/en.json';
import esContactTranslations from './contact/es.json';
import itContactTranslations from './contact/it.json';
import deContactTranslations from './contact/de.json';

// Use Cases
import frUseCasesTranslations from './use-cases/fr.json';
import enUseCasesTranslations from './use-cases/en.json';
import esUseCasesTranslations from './use-cases/es.json';
import itUseCasesTranslations from './use-cases/it.json';
import deUseCasesTranslations from './use-cases/de.json';

// Public Header
import frPublicHeaderTranslations from './public-header/fr.json';
import enPublicHeaderTranslations from './public-header/en.json';
import esPublicHeaderTranslations from './public-header/es.json';
import itPublicHeaderTranslations from './public-header/it.json';
import dePublicHeaderTranslations from './public-header/de.json';
import ptPublicHeaderTranslations from './public-header/pt.json';
import ukPublicHeaderTranslations from './public-header/uk.json';
import ruPublicHeaderTranslations from './public-header/ru.json';
import lbPublicHeaderTranslations from './public-header/lb.json';

// Public Footer
import frPublicFooterTranslations from './public-footer/fr.json';
import enPublicFooterTranslations from './public-footer/en.json';
import esPublicFooterTranslations from './public-footer/es.json';
import itPublicFooterTranslations from './public-footer/it.json';
import dePublicFooterTranslations from './public-footer/de.json';
import ptPublicFooterTranslations from './public-footer/pt.json';
import ukPublicFooterTranslations from './public-footer/uk.json';
import ruPublicFooterTranslations from './public-footer/ru.json';
import lbPublicFooterTranslations from './public-footer/lb.json';

// Login
import frLoginTranslations from './login/fr.json';
import enLoginTranslations from './login/en.json';
import esLoginTranslations from './login/es.json';
import itLoginTranslations from './login/it.json';
import deLoginTranslations from './login/de.json';

import arLandingTranslations from './landing/ar.json';
import arPricingTranslations from './pricing/ar.json';
import arAccessibilityTranslations from './accessibility/ar.json';
import arAboutTranslations from './about/ar.json';
import arContactTranslations from './contact/ar.json';
import arUseCasesTranslations from './use-cases/ar.json';
import arPublicHeaderTranslations from './public-header/ar.json';
import arPublicFooterTranslations from './public-footer/ar.json';
import arLoginTranslations from './login/ar.json';


import frConsentTranslations from './consent/fr.json';
import enConsentTranslations from './consent/en.json';
import esConsentTranslations from './consent/es.json';
import itConsentTranslations from './consent/it.json';
import deConsentTranslations from './consent/de.json';
import arConsentTranslations from './consent/ar.json';
import ptConsentTranslations from './consent/pt.json';
import ukConsentTranslations from './consent/uk.json';
import ruConsentTranslations from './consent/ru.json';
import lbConsentTranslations from './consent/lb.json';

import trLandingTranslations from './landing/tr.json';
import trPricingTranslations from './pricing/tr.json';
import trAccessibilityTranslations from './accessibility/tr.json';
import trAboutTranslations from './about/tr.json';
import trContactTranslations from './contact/tr.json';
import trUseCasesTranslations from './use-cases/tr.json';
import trPublicHeaderTranslations from './public-header/tr.json';
import trPublicFooterTranslations from './public-footer/tr.json';
import trLoginTranslations from './login/tr.json';
import trConsentTranslations from './consent/tr.json';

import frLoPublicSiteTranslations from './lo-public-site/fr.json';
import enLoPublicSiteTranslations from './lo-public-site/en.json';
import esLoPublicSiteTranslations from './lo-public-site/es.json';
import deLoPublicSiteTranslations from './lo-public-site/de.json';
import itLoPublicSiteTranslations from './lo-public-site/it.json';
import arLoPublicSiteTranslations from './lo-public-site/ar.json';
import ptLoPublicSiteTranslations from './lo-public-site/pt.json';
import ukLoPublicSiteTranslations from './lo-public-site/uk.json';
import ruLoPublicSiteTranslations from './lo-public-site/ru.json';
import lbLoPublicSiteTranslations from './lo-public-site/lb.json';
import trLoPublicSiteTranslations from './lo-public-site/tr.json';

import zghLandingTranslations from './landing/zgh.json';
import zghPricingTranslations from './pricing/zgh.json';
import zghAccessibilityTranslations from './accessibility/zgh.json';
import zghAboutTranslations from './about/zgh.json';
import zghContactTranslations from './contact/zgh.json';
import zghUseCasesTranslations from './use-cases/zgh.json';
import zghPublicHeaderTranslations from './public-header/zgh.json';
import zghPublicFooterTranslations from './public-footer/zgh.json';
import zghLoginTranslations from './login/zgh.json';
import zghConsentTranslations from './consent/zgh.json';
import zghLoPublicSiteTranslations from './lo-public-site/zgh.json';
import zghLyrraOneLandingTranslations from './lyrraone-landing/zgh.json';
import zghLyrraOnePricingTranslations from './lyrraone-pricing/zgh.json';

const ptLandingMerged = mergePublicLocale(enLandingTranslations, landingPtPatch);
const ukLandingMerged = mergePublicLocale(enLandingTranslations, landingUkPatch);
const ruLandingMerged = mergePublicLocale(enLandingTranslations, landingRuPatch);
const lbLandingMerged = mergePublicLocale(enLandingTranslations, landingLbPatch);

export const translations: Record<Language, any> = {
  fr: {
    landing: frLandingTranslations,
    lyrraoneLanding: frLyrraOneLandingTranslations,
    lyrraonePricing: frLyrraOnePricingTranslations,
    pricing: frPricingTranslations,
    accessibilityPage: frAccessibilityTranslations.accessibilityPage,
    about: frAboutTranslations,
    contact: frContactTranslations,
    useCases: frUseCasesTranslations,
    publicHeader: frPublicHeaderTranslations,
    publicFooter: frPublicFooterTranslations,
    login: frLoginTranslations,
    consent: frConsentTranslations,
    loPublicSite: frLoPublicSiteTranslations,
  },
  en: {
    landing: enLandingTranslations,
    lyrraoneLanding: enLyrraOneLandingTranslations,
    lyrraonePricing: enLyrraOnePricingTranslations,
    pricing: enPricingTranslations,
    accessibilityPage: enAccessibilityTranslations.accessibilityPage,
    about: enAboutTranslations,
    contact: enContactTranslations,
    useCases: enUseCasesTranslations,
    publicHeader: enPublicHeaderTranslations,
    publicFooter: enPublicFooterTranslations,
    login: enLoginTranslations,
    consent: enConsentTranslations,
    loPublicSite: enLoPublicSiteTranslations,
  },
  es: {
    lyrraoneLanding: enLyrraOneLandingTranslations,
    lyrraonePricing: enLyrraOnePricingTranslations,
    landing: esLandingTranslations,
    pricing: esPricingTranslations,
    accessibilityPage: esAccessibilityTranslations.accessibilityPage,
    about: esAboutTranslations,
    contact: esContactTranslations,
    useCases: esUseCasesTranslations,
    publicHeader: esPublicHeaderTranslations,
    publicFooter: esPublicFooterTranslations,
    login: esLoginTranslations,
    consent: esConsentTranslations,
    loPublicSite: esLoPublicSiteTranslations,
  },
  it: {
    lyrraoneLanding: enLyrraOneLandingTranslations,
    lyrraonePricing: enLyrraOnePricingTranslations,
    landing: itLandingTranslations,
    pricing: itPricingTranslations,
    accessibilityPage: itAccessibilityTranslations.accessibilityPage,
    about: itAboutTranslations,
    contact: itContactTranslations,
    useCases: itUseCasesTranslations,
    publicHeader: itPublicHeaderTranslations,
    publicFooter: itPublicFooterTranslations,
    login: itLoginTranslations,
    consent: itConsentTranslations,
    loPublicSite: itLoPublicSiteTranslations,
  },
  de: {
    lyrraoneLanding: enLyrraOneLandingTranslations,
    lyrraonePricing: enLyrraOnePricingTranslations,
    landing: deLandingTranslations,
    pricing: dePricingTranslations,
    accessibilityPage: deAccessibilityTranslations.accessibilityPage,
    about: deAboutTranslations,
    contact: deContactTranslations,
    useCases: deUseCasesTranslations,
    publicHeader: dePublicHeaderTranslations,
    publicFooter: dePublicFooterTranslations,
    login: deLoginTranslations,
    consent: deConsentTranslations,
    loPublicSite: deLoPublicSiteTranslations,
  },
  ar: {
    lyrraoneLanding: enLyrraOneLandingTranslations,
    lyrraonePricing: enLyrraOnePricingTranslations,
    landing: arLandingTranslations,
    pricing: arPricingTranslations,
    accessibilityPage: arAccessibilityTranslations.accessibilityPage,
    about: arAboutTranslations,
    contact: arContactTranslations,
    useCases: arUseCasesTranslations,
    publicHeader: arPublicHeaderTranslations,
    publicFooter: arPublicFooterTranslations,
    login: arLoginTranslations,
    consent: arConsentTranslations,
    loPublicSite: arLoPublicSiteTranslations,
  },
  /** Pages tarifaires / contact / etc. : repli sur l’anglais tant que des fichiers dédiés ne sont pas ajoutés. La home fusionne le bloc `decision` traduit. */
  pt: {
    lyrraoneLanding: enLyrraOneLandingTranslations,
    lyrraonePricing: enLyrraOnePricingTranslations,
    landing: ptLandingMerged,
    pricing: enPricingTranslations,
    accessibilityPage: enAccessibilityTranslations.accessibilityPage,
    about: enAboutTranslations,
    contact: enContactTranslations,
    useCases: enUseCasesTranslations,
    publicHeader: ptPublicHeaderTranslations,
    publicFooter: ptPublicFooterTranslations,
    login: enLoginTranslations,
    consent: ptConsentTranslations,
    loPublicSite: ptLoPublicSiteTranslations,
  },
  uk: {
    lyrraoneLanding: enLyrraOneLandingTranslations,
    lyrraonePricing: enLyrraOnePricingTranslations,
    landing: ukLandingMerged,
    pricing: enPricingTranslations,
    accessibilityPage: enAccessibilityTranslations.accessibilityPage,
    about: enAboutTranslations,
    contact: enContactTranslations,
    useCases: enUseCasesTranslations,
    publicHeader: ukPublicHeaderTranslations,
    publicFooter: ukPublicFooterTranslations,
    login: enLoginTranslations,
    consent: ukConsentTranslations,
    loPublicSite: ukLoPublicSiteTranslations,
  },
  ru: {
    lyrraoneLanding: enLyrraOneLandingTranslations,
    lyrraonePricing: enLyrraOnePricingTranslations,
    landing: ruLandingMerged,
    pricing: enPricingTranslations,
    accessibilityPage: enAccessibilityTranslations.accessibilityPage,
    about: enAboutTranslations,
    contact: enContactTranslations,
    useCases: enUseCasesTranslations,
    publicHeader: ruPublicHeaderTranslations,
    publicFooter: ruPublicFooterTranslations,
    login: enLoginTranslations,
    consent: ruConsentTranslations,
    loPublicSite: ruLoPublicSiteTranslations,
  },
  lb: {
    lyrraoneLanding: enLyrraOneLandingTranslations,
    lyrraonePricing: enLyrraOnePricingTranslations,
    landing: lbLandingMerged,
    pricing: enPricingTranslations,
    accessibilityPage: enAccessibilityTranslations.accessibilityPage,
    about: enAboutTranslations,
    contact: enContactTranslations,
    useCases: enUseCasesTranslations,
    publicHeader: lbPublicHeaderTranslations,
    publicFooter: lbPublicFooterTranslations,
    login: enLoginTranslations,
    consent: lbConsentTranslations,
    loPublicSite: lbLoPublicSiteTranslations,
  },
  tr: {
    lyrraoneLanding: enLyrraOneLandingTranslations,
    lyrraonePricing: enLyrraOnePricingTranslations,
    landing: trLandingTranslations,
    pricing: trPricingTranslations,
    accessibilityPage: trAccessibilityTranslations.accessibilityPage,
    about: trAboutTranslations,
    contact: trContactTranslations,
    useCases: trUseCasesTranslations,
    publicHeader: trPublicHeaderTranslations,
    publicFooter: trPublicFooterTranslations,
    login: trLoginTranslations,
    consent: trConsentTranslations,
    loPublicSite: trLoPublicSiteTranslations,
  },
  /** Amazighe (zgh) — traductions marketing générées depuis le français / contenu Maroc. */
  zgh: {
    lyrraoneLanding: zghLyrraOneLandingTranslations,
    lyrraonePricing: zghLyrraOnePricingTranslations,
    landing: zghLandingTranslations,
    pricing: zghPricingTranslations,
    accessibilityPage: zghAccessibilityTranslations.accessibilityPage,
    about: zghAboutTranslations,
    contact: zghContactTranslations,
    useCases: zghUseCasesTranslations,
    publicHeader: zghPublicHeaderTranslations,
    publicFooter: zghPublicFooterTranslations,
    login: zghLoginTranslations,
    consent: zghConsentTranslations,
    loPublicSite: zghLoPublicSiteTranslations,
  },
};
